define('app/editor/MonitorSegmentsView',['require','glu/itemView','./SegmentView','glu/model','./dialogs/SelectMonitorDefinitionDialogView','glu/dialog','hbs!./MonitorSegmentsView.hbs','glu/util'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		SegmentView = require('./SegmentView'),
		Model = require('glu/model'),
		SelectMonitorDefinitionDialogView = require('./dialogs/SelectMonitorDefinitionDialogView'),
		dialog = require('glu/dialog'),
		tmpl = require('hbs!./MonitorSegmentsView.hbs'),
		_ = require('glu/util');

	return ItemView.extend({

		template: tmpl,

		dialog: dialog,

		events: {
			'click .select-segments-button': 'openSelectMetricsDialog'
		},

		initialize: function(options) {
			this.model = options.model;
			this.listenTo(this.model, 'monitor:change', this.render);
		},

		onRender: function() {
			var self = this;
			var monitor = this.model;

			_.each(monitor.getSegments(), function(id) {
				var domain = monitor.getDomain();

				var segment = _.find(domain.getSegments(), function(s) {
					return s.getId() === id;
				});

				if (segment) {
					var segmentView = new SegmentView({
						model: segment,
						segments: domain.getSegments(),
						monitor: monitor
					});
					var viewRender = segmentView.render().el;
					self.$el.find('.segment-list').append(viewRender);
				}
			});
		},

		openSelectMetricsDialog: function(e) {
			var self = this;

			if (e) {
				e.preventDefault();
			}

			// renew the view, otherwise events are not picked up
			if (self.selectMonitorDefinitionDialogView) {
				self.selectMonitorDefinitionDialogView.remove();
			}

			var monitor = self.model;
			self.selectMonitorDefinitionDialogView = new SelectMonitorDefinitionDialogView({
				className: 'modal-select-metrics',
				mode: 'segments',
				model: new Model({
					domain: monitor.get('domain')
				})
			});

			self.listenTo(self.selectMonitorDefinitionDialogView, 'thisdialog:selectedefinition', function(metricIds, segmentIds) {
				_.each(metricIds, function(id) {
					monitor.addMetric(id);
				});
				_.each(segmentIds, function(id) {
					monitor.addSegment(id);
				});
				monitor.trigger('monitor:change');
				this.appBus.trigger('monitor:refresh');
				self.dialog.close();
			});

			self.dialog.open(self.selectMonitorDefinitionDialogView);

		},

		serializeData: function() {
			return this;
		}

	});

});

